<template>
  <section class="flex flex-column flex-justify-start p-2">
    <article class="flex flex-column flex-justify-start flex-align-start">
      <h1>{{ $t('header.services') }}</h1>
    </article>

    <article class="flex flex-column flex-justify-center flex-align-start">
      <div class="justify-content-60 article-text">
        <h4>
          {{ $t('services.article_1_title') }}
        </h4>
        <p>
          {{ $t('services.article_1_info') }}.
        </p>
        <a href="https://wikipep.com.br" target="_blank" class="article-link">
          {{ $t('services.article_1_link_text') }}
        </a>
      </div>
    </article>
  </section>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  computed: {
    ...mapGetters([]),
  },
  data() {
    return {}
  },
  methods: {},
  beforeDestroy() {}
}
</script>

<style scoped>
section {
  min-height: calc(100vh - 80px);
  width: auto;
}

section > article {
  height: auto;
  padding: 10px;
}

section > article > div {
  height: 100%;
  padding: 40px;
  border-radius: 1em;
  background: #efefef;  /* fallback for old browsers */
  background: -webkit-linear-gradient(145deg, #efefef 25%, #fff 100%);  /* Chrome 10-25, Safari 5.1-6 */
  background: linear-gradient(145deg, #efefef 25%, #fff 100%); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
}

.article-text {
  /* animation: slide-in 1ms ease-in-out;
  animation-timeline: view();
  animation-range: cover 0% cover 50%; */
  animation: slide-up 1s ease;
}

.article-link {
  background: -webkit-linear-gradient(90deg, #2264fd, #71a8f9);
  background: linear-gradient(90deg, #2264fd, #71a8f9);
  color: #fff;
  padding: 5px 10px;
  border-radius: 0.5rem;
  box-shadow: 0px 1px 10px rgba(0, 0, 0, 0.25);
  cursor: pointer;
  text-decoration: none;
}

section > article > p {
  font-size: 14px;
}
</style>